// harnessHonorsModelEnv reports whether the named harness reads its
// model from an env var the wizard sets at spawn (ANTHROPIC_MODEL for
// claude-code, OPENAI_MODEL for codex). Gemini / copilot / pi
// configure their model inside their own UI and ignore anything the
// wizard would supply, so the wizard skips the model picker for those
// harnesses and submits ai_brain_model_id as NULL.
//
// This is the source-of-truth for the wizard's branching. The Go side
// has the same function in hearth-cmd-cli/select.go; the two must stay
// in sync (both are tested with the same mapping).
export function harnessHonorsModelEnv(name: string | undefined): boolean {
  return name === 'claude-code' || name === 'codex'
}
